import api from '../../api/client';
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import PaymentsPage from "../forms/PaymentsPage";

const TransactionHistory = ({ resetTypeInput }) => {
  return (
    <React.Fragment>
      <PaymentsPage />
    </React.Fragment>
  );
};

export default TransactionHistory;
